module.exports = __webpack_public_path__ + "static/media/r386.6ae3380c.jpg";